import { createSelector } from "@reduxjs/toolkit";
import { RootState } from "store";
import Reducers from "types/Reducers";

export const selectQuizEvents = (state:RootState) => state[Reducers.QuizEvents].quizEvents;

export const selectEventById = createSelector(
  [
    selectQuizEvents,
    (_, props:{ eventId:string | undefined }) => props
  ],
  (quizEvents, { eventId }) => {
    if (!eventId || !quizEvents) return null;
    return quizEvents.find(event => event.id === eventId) || null;
  }
)
